import React, { FC, useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import LinkEntityModal from "../../../../../../../../../../../components/AppLink/LinkEntityModal/LinkEntityModal";
import {
	LinkEntityApi,
	LinkedApi,
	ProductApi,
	PurchaseApi,
} from "../../../../../../../../../../../services/Api/Organization/types";
import PurchaseItemsCardTable from "./PurchaseItemsCardTable";

interface Props {
	purchase: PurchaseApi;
	onUpdate?: (data: PurchaseApi) => void;
	fileImportPreviewMode?: boolean;
}

const PurchaseItemsCard: FC<Props> = ({ purchase, onUpdate, fileImportPreviewMode }) => {
	const { t } = useTranslation();
	const [productToLink, setProductToLink] = useState<LinkEntityApi | undefined>(undefined);
	const [productIndexToLink, setProductIndexToLink] = useState<number>(-1);

	const handleRefreshPage = () => {
		const unlinkedItems = purchase.items.filter((item) => !item.product);
		if (unlinkedItems.length === 1) {
			window.location.reload();
		}
	};

	const onUpdateLinkedProductWithLink = (linkedProduct: LinkedApi, volume?: number) => {
		if (onUpdate) {
			const items = [...purchase.items];
			const itemToUpdate = { ...items[productIndexToLink] };
			if (!linkedProduct.skipped) {
				let newItem = {
					...itemToUpdate,
					volume: volume ?? itemToUpdate.volume,
				};
				if (linkedProduct.resource) {
					newItem = {
						...newItem,
						product: {
							...itemToUpdate.product,
							id: linkedProduct.resource?.id,
							name: linkedProduct.resource?.name,
							type: linkedProduct.resource?.product_type,
						},
					};
				}
				items[productIndexToLink] = { ...newItem };
				onUpdate({
					...purchase,
					items,
				});
			} else {
				const unlinkedProductBox = document.getElementById(`unlinked-product-${itemToUpdate.id}`);
				if (unlinkedProductBox) {
					unlinkedProductBox.className = "d-none";
				}
			}
			handleRefreshPage();
		}
	};

	const onUpdateLinkedProductWithoutLink = (product: ProductApi) => {
		if (onUpdate) {
			const items = [...purchase.items];
			const itemToUpdate = { ...items[productIndexToLink] };
			if (product) {
				items[productIndexToLink] = { ...itemToUpdate, product };
			} else {
				items.splice(productIndexToLink, 1);
			}
			onUpdate({
				...purchase,
				items,
			});
			handleRefreshPage();
		}
	};

	const onHide = () => {
		setProductToLink(undefined);
		setProductIndexToLink(-1);
	};

	return (
		<Card className="card-box positions-card">
			<Card.Body>
				<h5 className="card-title">{t("common.word.items")}</h5>
				<PurchaseItemsCardTable
					purchase={purchase}
					setProductToLink={setProductToLink}
					setProductIndexToLink={setProductIndexToLink}
					fileImportPreviewMode={fileImportPreviewMode}
				/>
			</Card.Body>
			{productToLink && !fileImportPreviewMode && (
				<LinkEntityModal
					onHide={onHide}
					isShown={!!productToLink}
					key={productToLink.id}
					onSuccess={productToLink.id ? onUpdateLinkedProductWithLink : onUpdateLinkedProductWithoutLink}
					item={productToLink}
					channel={purchase?.channel}
				/>
			)}
		</Card>
	);
};

export default PurchaseItemsCard;
